import { getFileUploadBaseUrl } from '~/helpers/api/getBaseUrl'
import { defineFileUploadFetch } from '~/helpers/fetch'

export function useProvideFileUploadFetch() {
  const fileUploadFetch = defineFileUploadFetch(
    $fetch.create({
      baseURL: getFileUploadBaseUrl(),
      credentials: 'include',
    }),
  )

  return {
    fileUploadFetch,
  }
}
